@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.rides
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint

object CancelRideAdminEndpoint
    : EndPoint<CancelRideAdminEndpoint.Request, CancelRideAdminEndpoint.Response>() {
    class Request(
        val rideId: KmmLong,
        val reason: String,
    )

    class Response()
}